import { PropertyInfoContextDto } from '../contexts/dtos/PropertyInfoContextDto';

export const PropertyInfoReducer = (state: PropertyInfoContextDto, action: PropertyInfoReducerType) => {
  let newState;
  switch (action.type) {
    case PropertyInfoReducerActionOptions.Update:
      newState = new PropertyInfoContextDto();
      // console.log('Inside PropertyInfoReducer', action);
      Object.assign(newState, action.propertyInfo);
      return newState;
    default:
      return state;
  }
};

export class PropertyInfoReducerActionOptions {
  static Update = 'Update';
}

export interface PropertyInfoReducerType {
  type: PropertyInfoReducerActionOptions;
  propertyInfo: PropertyInfoContextDto | null;
}
